import loyaltySymbol from "../assets/walkers/loyalty.png";

const loyaltyBuilder = (loyalty, font) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = 150;
  canvas.height = 80;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.font = font;
  return new Promise((resovle, reject) => {
    const img = document.createElement("img");
    img.src = loyaltySymbol;
    img.onload = () => resovle(img);
  }).then((img) => {
    ctx.drawImage(img, 0, 0, 150, 80);
    const loyaltyString = `${loyalty}`;
    const halfTextLength = Math.round(ctx.measureText(loyaltyString).width / 2);
    const halfCanvas = Math.round(canvas.width / 2);
    const x = halfCanvas - halfTextLength;
    ctx.fillStyle = "#FFF";
    ctx.fillText(loyaltyString, x, 57);
    return canvas.toDataURL("image/png");
  });
};

export default loyaltyBuilder;
